// Mock data for Tranquil Acupuncture website

export const services = [
{
  id: 'acupuncture',
  name: 'Acupuncture',
  shortDescription: 'Traditional Chinese medicine technique using fine needles to restore balance and promote natural healing.',
  fullDescription: 'Our acupuncture treatments address a wide range of conditions including pain management, stress relief, digestive issues, and overall wellness. Each session is tailored to your specific needs.',
  price: "70 \u20AC",
  duration: "60-75 minutes",
  image: 'https://customer-assets.emergentagent.com/job_traditional-medicine-3/artifacts/ulq4khwv_ChatGPT%20Image%20Apr%2022%2C%202026%2C%2011_16_10%20AM.png',
  benefits: [
  'Stress and anxiety reduction',
  'Better digestion, more energy, pain relief and management, improved sleep quality',
  'and much more...',
  'Enhanced immune function',
  'Digestive health support']

},
{
  id: 'aculifting',
  name: 'Acu-lifting',
  shortDescription: "Natural facial rejuvenation using massage and acupuncture techniques to enhance skin tone and reduce signs of aging.",
  fullDescription: 'Acu-lifting is a natural, non-invasive alternative to cosmetic procedures. By stimulating collagen production and improving circulation, this treatment helps reduce fine lines, improve skin tone, and restore a youthful glow.',
  price: "90 \u20AC",
  duration: "90 minutes",
  image: 'https://customer-assets.emergentagent.com/job_traditional-medicine-3/artifacts/kqzkmuy3_ChatGPT%20Image%20Apr%2022%2C%202026%2C%2011_14_24%20AM%20-%20Copy.png',
  benefits: [
  'Reduces fine lines and wrinkles',
  'Improves skin elasticity',
  'Enhances facial muscle tone',
  'Promotes natural collagen production',
  'Creates a healthy, radiant glow']

},
{
  id: 'korean-relaxation',
  name: 'Korean Relaxation',
  shortDescription: 'Therapeutic approach combining traditional Korean techniques with acupuncture points stimulation through acupressure.',
  fullDescription: 'Experience deep relaxation and healing with our Korean relaxation therapy. This gentle yet effective treatment combines traditional Korean massage techniques with acupressure to release tension and restore balance.',
  price: "50 \u20AC",
  duration: "30-45 minutes",
  image: 'https://customer-assets.emergentagent.com/job_traditional-medicine-3/artifacts/zn8yvcy7_download%20%281%29.jpeg',
  benefits: [
  'Deep muscle relaxation',
  'Stress and tension relief',
  'Improved circulation',
  'Enhanced energy flow',
  'Mental clarity and calm']

}];


export const practitioner = {
  name: 'Dr. Sarah Chen, L.Ac.',
  title: 'Licensed Acupuncturist & Traditional Chinese Medicine Practitioner',
  credentials: [
  'Licensed Acupuncturist (L.Ac.)',
  'Master of Science in Traditional Chinese Medicine',
  'Certified in Facial Acupuncture',
  '10+ years of clinical experience'],

  bio: 'With over a decade of experience in Traditional Chinese Medicine, Dr. Chen is dedicated to helping patients achieve optimal health through natural, holistic approaches. She combines ancient wisdom with modern techniques to provide personalized care for each individual.',
  image: 'https://customer-assets.emergentagent.com/job_traditional-medicine-3/artifacts/jn6q967u_image00009%20-%20Copy.jpeg'
};

export const testimonials = [
{
  id: 1,
  name: 'Jennifer M.',
  text: 'After struggling with chronic pain for years, Dr. Chen\'s acupuncture treatments have been life-changing. I finally feel like myself again!',
  rating: 5,
  service: 'Acupuncture'
},
{
  id: 2,
  name: 'Michael T.',
  text: 'The acu-lifting treatments have given me visible results without any invasive procedures. My skin looks and feels amazing!',
  rating: 5,
  service: 'Acu-lifting'
},
{
  id: 3,
  name: 'Lisa K.',
  text: 'The Korean relaxation therapy is the perfect way to unwind after a stressful week. Dr. Chen creates such a peaceful, healing environment.',
  rating: 5,
  service: 'Korean Relaxation'
}];


export const availableTimeSlots = [
'11:00 AM',
'12:00 PM',
'01:00 PM',
'02:00 PM',
'03:00 PM',
'04:00 PM',
'05:00 PM'];


export const bookingHistory = [];

export const addBooking = (booking) => {
  bookingHistory.push({
    ...booking,
    id: Date.now(),
    createdAt: new Date().toISOString()
  });
  console.log('Booking added (mock):', booking);
  return { success: true, message: 'Booking submitted successfully!' };
};